import React from 'react';
import { Button } from 'antd';
import { internationalizeNumericValue } from '@/ts/utils';

interface SelectionBannerProps {
    selectedCount: number;
    totalCount: number;
    isAllPagesSelected: boolean;
    isHeaderSelection: boolean;
    onSelectAllPages: () => void;
    onClearSelection: () => void;
    itemType: 'Keywords' | 'Products';
}

const SelectionBanner: React.FC<SelectionBannerProps> = ({
    selectedCount,
    totalCount,
    isAllPagesSelected,
    isHeaderSelection,
    onSelectAllPages,
    onClearSelection,
    itemType,
}) => {
    if (selectedCount === 0 || !isHeaderSelection) return null;

    return (
        <div
            className="bg-light border rounded p-3 my-2 d-flex align-items-center justify-content-center shadow-sm"
            style={{
                fontSize: '13px',
                color: '#595959',
            }}
        >
            <div className="d-flex align-items-center text-center" style={{ gap: '8px' }}>
                <span style={{ fontWeight: 400 }}>
                    {isAllPagesSelected ? (
                        <>
                            All <strong>{internationalizeNumericValue(totalCount)}</strong> {itemType.toLowerCase()} are selected.
                        </>
                    ) : (
                        <>
                            All <strong>{internationalizeNumericValue(selectedCount)}</strong> {itemType.toLowerCase()} on this page are selected.
                            {totalCount > selectedCount && (
                                <>
                                    {' '}
                                    <Button
                                        type="link"
                                        onClick={onSelectAllPages}
                                        style={{ 
                                            color: '#1890ff',
                                            textDecoration: 'underline',
                                            fontSize: '13px',
                                            fontWeight: 400,
                                            padding: 0,
                                            height: 'auto',
                                            border: 'none'
                                        }}
                                    >
                                        Select all {internationalizeNumericValue(totalCount)} {itemType.toLowerCase()}
                                    </Button>
                                </>
                            )}
                        </>
                    )}
                </span>
                <span style={{ margin: '0 8px', color: '#d9d9d9' }}>|</span>
                <Button
                    type="link"
                    onClick={onClearSelection}
                    style={{ 
                        color: '#1890ff',
                        textDecoration: 'underline',
                        fontSize: '13px',
                        fontWeight: 400,
                        padding: 0,
                        height: 'auto',
                        border: 'none'
                    }}
                >
                    Clear selection
                </Button>
            </div>
        </div>
    );
};

export default SelectionBanner;
